import * as React from 'react';

export interface BreadcrumbsProps {
  dataHook?: string;
  items: BreadcrumbsItem[];
  onClick?: (item: BreadcrumbsItem) => any;
  activeId?: string | number;
  size?: BreadcrumbsSize;
  itemMaxWidth?: React.CSSProperties['maxWidth'];
  theme?: BreadcrumbsSkin;
  skin?: BreadcrumbsSkin;
}

export default class Breadcrumbs extends React.PureComponent<BreadcrumbsProps> {}

export type BreadcrumbsItem = {
  id: string | number;
  value: React.ReactNode;
  link?: string;
  customElement?: any;
  disabled?: boolean;
};

export type BreadcrumbsSize = 'medium' | 'large' | 'small';

export type BreadcrumbsSkin =
  | 'onWhiteBackground'
  | 'onGrayBackground'
  | 'onDarkBackground';

export type BreadcrumbsTheme = BreadcrumbsSkin;
